export default {
  margin: '0',
  lineHeight: '21px',
  whiteSpace: 'pre',
}
